const BASE_URL = process.env.VUE_APP_TRADING_URL;
let controller;

const createAbortController = () => {
  if (controller) {
    controller.abort();
  }
  controller = new AbortController();
  return controller;
};

export const getPositionList = async (userNo) => {
  const response = await fetch(
    `${BASE_URL}/user/get_position_list?user_no=${userNo}`
  );
  const data = await response.json();
  return data.results;
};

export const getPositionHistoryList = async (userNo) => {
  const response = await fetch(
    `${BASE_URL}/user/get_position_history?user_no=${userNo}`
  );
  const data = await response.json();
  return data.results;
};

export const getOrderHistoryList = async (userNo) => {
  const response = await fetch(
    `${BASE_URL}/user/get_order_list?user_no=${userNo}`
  );
  const data = await response.json();
  return data.results;
};

export const getOpenOrderList = async (userNo) => {
  const response = await fetch(
    `${BASE_URL}/user/get_openorder_list?user_no=${userNo}`
  );
  const data = await response.json();
  return data.results;
};

export const postCancelOrder = async (userNo, ordid) => {
  const controller = createAbortController();

  const response = await fetch(
    `${BASE_URL}/trading/cancle_order?user_no=${userNo}&ordid=${ordid}`,
    {
      method: "POST",
      signal: controller.signal,
    }
  );
  const data = await response.json();
  return data;
};
export const postCancelOrderAll = async (userNo, ordid) => {
  const controller = createAbortController();
  const response = await fetch(
    `${BASE_URL}/trading/all_cancle_order?user_no=${userNo}&ordid=${ordid}`,
    {
      method: "POST",
      signal: controller.signal,
    }
  );
  const data = await response.json();
  return data;
};
export const postClosePositionAll = async (userNo) => {
  const controller = createAbortController();
  const response = await fetch(
    `${BASE_URL}/trading/all_close_position?user_no=${userNo}`,
    {
      method: "POST",
      signal: controller.signal,
    }
  );
  const data = await response.json();
  return data;
};
export const postClosePosition = async (userNo, positionId) => {
  const controller = createAbortController();
  const response = await fetch(
    `${BASE_URL}/trading/close_position?user_no=${userNo}&position_id=${positionId}`,
    {
      method: "POST",
      signal: controller.signal,
    }
  );
  const data = await response.json();
  return data;
};
export const postPositionTpsl = async (params) => {
  const controller = createAbortController();
  const response = await fetch(`${BASE_URL}/trading/position_tp_sl?${params}`, {
    method: "POST",
    signal: controller.signal,
  });
  const data = await response.json();
  return data;
};
